// Feature switches for parts of the app that have been superseded but not thrown away.
//
// Both default to off. Set the matching REACT_APP_* variable to "true" in .env (or via the
// runtime env injection used in Docker, window._env_) to bring the section back without
// touching any code — the components themselves are untouched and still fully functional.

const flag = (name) => {
  const value = window._env_?.[name] ?? process.env[name];
  return String(value).toLowerCase() === 'true';
};

export const FEATURES = {
  // The standalone "Details" section built on TrainDetail.js. Superseded by the train panel
  // on the map, which carries the same information next to the live route.
  trainDetailSection: flag('REACT_APP_FEATURE_DETAIL_SECTION'),

  // The right-hand column with the timetable (JourneyList) and the train search
  // (TrainSearch). Both moved into the map's side panel.
  timetableColumn: flag('REACT_APP_FEATURE_TIMETABLE_COLUMN'),
};
